import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocumentListComponent } from "./components/document-list.component";
import { SharedModule } from "../../shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { DocumentPreviewComponent } from "./components/document-preview/document-preview.component";
import { DocumentEditContactInfoComponent } from "./components/document-contact-info-modal/document-contact-info-modal.component";
import { DocumentGeneralRemarkModalComponent } from "./components/document-general-remark-modal/document-general-remark-modal.component";
import { DocumentRejectionModalComponent } from "./components/document-rejection-modal/document-rejection-modal.component";
import { DocumentViewerComponent } from "./components/document-viewer/document-viewer.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { SignedDocumentPreviewComponent } from "./components/signed-document-preview/signed-document-preview.component";
import { SignedDocumentApprovalComponent } from "./components/signed-document-approval/signed-document-approval.component";
import { SignedDocumentRejectionModalComponent } from "./components/signed-document-rejection-modal/signed-document-rejection-modal.component";
import { RejectedDocumentPreviewComponent } from "./components/rejected-document-preview/rejected-document-preview.component";
import { DocumentContactSearchComponent } from "./components/document-contact-info-modal/document-contact-search/document-contact-search.component";
import { CheckboxModule } from "primeng/checkbox";
import { MatMenuModule } from "@angular/material/menu";
import { SignedDocumentArchiveModalComponent } from "./components/signed-document-archive/signed-document-archive-modal.component";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
  declarations: [
    DocumentListComponent,
    DocumentPreviewComponent,
    DocumentEditContactInfoComponent,
    SignedDocumentApprovalComponent,
    DocumentGeneralRemarkModalComponent,
    DocumentRejectionModalComponent,
    DocumentViewerComponent,
    SignedDocumentPreviewComponent,
    SignedDocumentRejectionModalComponent,
    SignedDocumentArchiveModalComponent,
    RejectedDocumentPreviewComponent,
    DocumentContactSearchComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    CheckboxModule,
    MatMenuModule,
    TooltipModule,
  ],
  entryComponents: [
    DocumentGeneralRemarkModalComponent,
    DocumentRejectionModalComponent,
    DocumentEditContactInfoComponent,
    SignedDocumentRejectionModalComponent,
    SignedDocumentArchiveModalComponent,
  ],
})
export class DocumentListModule {}
